// faraday stream: keys merged over the base dictionary by locales/index.ts (so faraday.help / placeholder are overridden here).
export const en: Record<string, string> = {
  "faraday.placeholder": "Ask anything, tell me what to do, or attach a photo…",
  "faraday.attachPlaceholder": "What should I do with this? (optional)",
  "faraday.welcome": "I know this workspace end to end and I work through the same actions as the screens, as you. Ask me what matters today, find someone, add a customer, set a follow-up, draft a text, run a report, or build a Word or Excel file. Hand me a photo of an insurance card or a license and I file it where it belongs. Anything I change shows a receipt; the few things that need your OK show a Confirm button.",
  "faraday.notConfigured": "The assistant is not turned on for this deployment yet. Settings → Connections shows what is missing (an Anthropic API key).",
  "faraday.newChat": "New conversation",
  "faraday.chips": "Try",
  "faraday.chip.brief": "Today's brief",
  "faraday.chip.brief.text": "Brief me on today: what needs a decision, what is due, what is coming.",
  "faraday.chip.renewals": "Renewals",
  "faraday.chip.renewals.text": "Which renewals are coming up in the next 30 days and which have not been touched?",
  "faraday.chip.find": "Find",
  "faraday.chip.find.text": "Find ",
  "faraday.chip.add": "Add customer",
  "faraday.chip.add.text": "Add a new customer: ",
  "faraday.chip.scan": "Scan a card",
  "faraday.chip.scan.text": "Here is a photo. Read it and file it for ",
  "faraday.chip.text": "Draft a text",
  "faraday.chip.text.text": "Draft a text to ",
  "faraday.chip.report": "Book of business",
  "faraday.chip.report.text": "Show me the book of business: policies, premium by carrier and line, and the total.",
  "faraday.chip.walk": "Show me how",
  "faraday.chip.walk.text": "Show me how to ",
  "faraday.attach": "Attach a photo or file",
  "faraday.attachHint": "Photos (insurance cards, licenses, dec pages), PDFs, CSV files. Up to four.",
  "faraday.removeAttachment": "Remove attachment",
  "faraday.live": "Live data",
  "faraday.simulated": "Simulated",
  "faraday.draftReady": "Not sent yet. Press Send and the server checks consent, quiet hours and the allowlist, then shows the real status.",
  "faraday.noConsent": "No SMS consent on file for this customer; the server will hold the text.",
  "faraday.sendNow": "Send now",
  "faraday.discard": "Discard",
  "faraday.sentStatus": "Message status",
  "faraday.confirm": "Confirm",
  "faraday.confirmed": "Done",
  "faraday.confirmHint": "Nothing has changed yet. Confirm runs this as you, with the same checks and receipt as the screen.",
  "faraday.history": "Conversations",
  "faraday.searchHistory": "Search conversations",
  "faraday.noHistory": "No conversations yet",
  "faraday.noHistoryHint": "Everything you and Faraday talk about is kept here, per person, so you can pick a thread back up on any device.",
  "faraday.noMatches": "Nothing matches that search.",
  "faraday.today": "Today",
  "faraday.yesterday": "Yesterday",
  "faraday.thisWeek": "This week",
  "faraday.earlier": "Earlier",
  "faraday.message": "message",
  "faraday.messages": "messages",
  "faraday.rename": "Rename",
  "faraday.delete": "Delete",
  "faraday.deleteAsk": "Delete this conversation?",
  "faraday.historyFooter": "Conversations are private to you. Deleting one does not undo anything it did; the receipts stay in the audit trail.",
  "faraday.expired": "From an earlier conversation; no longer actionable.",
  "faraday.mode": "How Faraday works for you",
  "faraday.mode.ask": "Ask first",
  "faraday.mode.ask.hint": "Every change waits for your Confirm.",
  "faraday.mode.act": "Act",
  "faraday.mode.act.hint": "Ordinary changes run at once; only sensitive ones ask.",
  "faraday.remembered": "Remembered",
  "faraday.forgot": "Forgotten.",
};

export const es: Record<string, string> = {
  "faraday.placeholder": "Pregunta lo que sea, dime qué hacer o adjunta una foto…",
  "faraday.attachPlaceholder": "¿Qué hago con esto? (opcional)",
  "faraday.welcome": "Conozco este sistema de punta a punta y trabajo con las mismas acciones que las pantallas, como tú. Pídeme el resumen del día, buscar a alguien, agregar un cliente, programar un seguimiento, redactar un mensaje, generar un reporte o crear un archivo de Word o Excel. Pásame la foto de una tarjeta de seguro o una licencia y la archivo donde corresponde. Todo lo que cambio deja un recibo; lo poco que necesita tu visto bueno muestra un botón de Confirmar.",
  "faraday.notConfigured": "El asistente aún no está activado en esta instalación. En Configuración → Conexiones se ve qué falta (una clave de API de Anthropic).",
  "faraday.newChat": "Nueva conversación",
  "faraday.chips": "Prueba",
  "faraday.chip.brief": "Resumen de hoy",
  "faraday.chip.brief.text": "Dame el resumen de hoy: qué necesita una decisión, qué vence y qué viene.",
  "faraday.chip.renewals": "Renovaciones",
  "faraday.chip.renewals.text": "¿Qué renovaciones vienen en los próximos 30 días y cuáles no se han tocado?",
  "faraday.chip.find": "Buscar",
  "faraday.chip.find.text": "Buscar a ",
  "faraday.chip.add": "Agregar cliente",
  "faraday.chip.add.text": "Agregar un cliente nuevo: ",
  "faraday.chip.scan": "Escanear tarjeta",
  "faraday.chip.scan.text": "Aquí va una foto. Léela y archívala para ",
  "faraday.chip.text": "Redactar mensaje",
  "faraday.chip.text.text": "Redacta un mensaje para ",
  "faraday.chip.report": "Cartera",
  "faraday.chip.report.text": "Muéstrame la cartera de pólizas: pólizas, prima por aseguradora y línea, y el total.",
  "faraday.chip.walk": "Muéstrame cómo",
  "faraday.chip.walk.text": "Muéstrame cómo ",
  "faraday.attach": "Adjuntar foto o archivo",
  "faraday.attachHint": "Fotos (tarjetas de seguro, licencias, declaraciones), PDF, archivos CSV. Hasta cuatro.",
  "faraday.removeAttachment": "Quitar adjunto",
  "faraday.live": "Datos reales",
  "faraday.simulated": "Simulado",
  "faraday.draftReady": "Todavía no se envía. Presiona Enviar y el servidor verifica consentimiento, horario permitido y lista autorizada, y muestra el estado real.",
  "faraday.noConsent": "Este cliente no tiene consentimiento de SMS registrado; el servidor retendrá el mensaje.",
  "faraday.sendNow": "Enviar ahora",
  "faraday.discard": "Descartar",
  "faraday.sentStatus": "Estado del mensaje",
  "faraday.confirm": "Confirmar",
  "faraday.confirmed": "Hecho",
  "faraday.confirmHint": "Todavía no cambia nada. Confirmar lo ejecuta como tú, con las mismas verificaciones y recibo que la pantalla.",
  "faraday.history": "Conversaciones",
  "faraday.searchHistory": "Buscar conversaciones",
  "faraday.noHistory": "Todavía no hay conversaciones",
  "faraday.noHistoryHint": "Todo lo que hablas con Faraday se guarda aquí, por persona, para retomar cualquier hilo desde cualquier dispositivo.",
  "faraday.noMatches": "Nada coincide con esa búsqueda.",
  "faraday.today": "Hoy",
  "faraday.yesterday": "Ayer",
  "faraday.thisWeek": "Esta semana",
  "faraday.earlier": "Anteriores",
  "faraday.message": "mensaje",
  "faraday.messages": "mensajes",
  "faraday.rename": "Renombrar",
  "faraday.delete": "Eliminar",
  "faraday.deleteAsk": "¿Eliminar esta conversación?",
  "faraday.historyFooter": "Las conversaciones son privadas. Eliminar una no deshace lo que hizo; los recibos quedan en la bitácora.",
  "faraday.expired": "De una conversación anterior; ya no se puede ejecutar.",
  "faraday.mode": "Cómo trabaja Faraday contigo",
  "faraday.mode.ask": "Preguntar",
  "faraday.mode.ask.hint": "Cada cambio espera tu Confirmar.",
  "faraday.mode.act": "Actuar",
  "faraday.mode.act.hint": "Los cambios comunes se hacen al momento; solo los delicados preguntan.",
  "faraday.remembered": "Recordado",
  "faraday.forgot": "Olvidado.",
};
